<div class="integration-status">
  <div class="header">
    <div>
      <h2 *ngIf="isSftp">{{ 'INTEGRATION.SFTP.STATUS_TITLE' | translate }}</h2>
      <h2 *ngIf="!isSftp">{{ connection?.displayName || connection?.provider || ('INTEGRATION.STATUS.TITLE_FALLBACK' | translate) }}</h2>
      <div class="sub" *ngIf="!isSftp">
        {{ 'INTEGRATION.STATUS.CONNECTION_STATUS' | translate }}:
        <nz-tag
          *ngIf="connection"
          [nzColor]="connection.status === 'connected' ? 'green' : connection.status === 'error' ? 'red' : 'default'"
        >
          {{ connection.status }}
        </nz-tag>
      </div>
      <div class="sub" *ngIf="isSftp && sftpIntegration">
        <nz-tag>{{ lifecycleLabel(sftpIntegration.lifecycleStatus) | translate }}</nz-tag>
      </div>
    </div>

    <div class="header-actions">
      <button nz-button nzType="default" routerLink="/company/integrations">{{ 'INTEGRATION.COMMON.BACK' | translate }}</button>
      <button nz-button nzType="default" (click)="refreshAll()">{{ 'INTEGRATION.STATUS.REFRESH' | translate }}</button>
      <button *ngIf="!isSftp" nz-button nzType="default" (click)="testConnection()">{{ 'INTEGRATION.STATUS.TEST' | translate }}</button>
      <button nz-button nzType="default" (click)="goToSetup()">{{ (isSftp ? 'INTEGRATION.SFTP.CONNECTION_DETAILS' : 'INTEGRATION.STATUS.SETUP') | translate }}</button>
      <button *ngIf="!isSftp" nz-button nzType="primary" (click)="runSync()" [nzLoading]="loading">{{ 'INTEGRATION.STATUS.RUN_SYNC' | translate }}</button>
      <button *ngIf="isSftp && (sftpIntegration?.lifecycleStatus === 'awaiting_first_file' || sftpIntegration?.lifecycleStatus === 'active')" nz-button nzType="default" (click)="changeSftpLifecycle('pause')">{{ 'INTEGRATION.SFTP.PAUSE' | translate }}</button>
      <button *ngIf="isSftp && sftpIntegration?.lifecycleStatus === 'paused'" nz-button nzType="primary" (click)="changeSftpLifecycle('resume')">{{ 'INTEGRATION.SFTP.RESUME' | translate }}</button>
      <button *ngIf="isSftp && sftpIntegration?.lifecycleStatus !== 'disconnected'" nz-button nzType="link" (click)="changeSftpLifecycle('disconnect')">{{ 'INTEGRATION.STATUS.DISCONNECT' | translate }}</button>
      <button *ngIf="!isSftp" nz-button nzType="link" (click)="disconnect()">{{ 'INTEGRATION.STATUS.DISCONNECT' | translate }}</button>
    </div>
  </div>

  <div class="pause-row" *ngIf="connection && !isSftp">
    <label class="pause-label">{{ 'INTEGRATION.STATUS.PAUSED' | translate }}:</label>
    <nz-select
      style="min-width: 160px;"
      [ngModel]="connection.settings?.paused ? 'yes' : 'no'"
      (ngModelChange)="togglePaused($event === 'yes')"
    >
      <nz-option nzValue="no" [nzLabel]="'INTEGRATION.STATUS.PAUSED_OPTIONS.NO_ACTIVE' | translate"></nz-option>
      <nz-option nzValue="yes" [nzLabel]="'INTEGRATION.STATUS.PAUSED_OPTIONS.YES_PAUSED' | translate"></nz-option>
    </nz-select>
  </div>

  <div class="metrics" *ngIf="isSftp && sftpIntegration">
    <nz-descriptions nzBordered nzSize="small" [nzColumn]="1">
      <nz-descriptions-item *ngIf="sftpIntegration.endpoint" [nzTitle]="'INTEGRATION.SFTP.HOST' | translate">{{ sftpIntegration.endpoint.hostname }}</nz-descriptions-item>
      <nz-descriptions-item *ngIf="sftpIntegration.endpoint" [nzTitle]="'INTEGRATION.SFTP.PORT' | translate">{{ sftpIntegration.endpoint.port }}</nz-descriptions-item>
      <nz-descriptions-item *ngIf="sftpIntegration.endpoint" [nzTitle]="'INTEGRATION.SFTP.USERNAME' | translate">{{ sftpIntegration.endpoint.username }}</nz-descriptions-item>
      <nz-descriptions-item *ngIf="sftpIntegration.endpoint" [nzTitle]="'INTEGRATION.SFTP.UPLOAD_DIRECTORY' | translate">{{ sftpIntegration.endpoint.uploadDirectory }}</nz-descriptions-item>
      <nz-descriptions-item *ngIf="sftpIntegration.endpoint" [nzTitle]="'INTEGRATION.SFTP.HOST_FINGERPRINT' | translate">{{ sftpIntegration.endpoint.hostKeyFingerprint }}</nz-descriptions-item>
      <nz-descriptions-item [nzTitle]="'INTEGRATION.SFTP.REQUIRED_FILE' | translate">{{ sftpIntegration.acceptedFileName || '-' }}</nz-descriptions-item>
      <nz-descriptions-item [nzTitle]="'INTEGRATION.SFTP.FINGERPRINT' | translate">{{ sftpIntegration.sshKeyFingerprint || '-' }}</nz-descriptions-item>
      <nz-descriptions-item [nzTitle]="'INTEGRATION.SFTP.LAST_RECEIVED' | translate">{{ formatSftpDateTime(sftpIntegration.lastReceivedAt) }}</nz-descriptions-item>
      <nz-descriptions-item [nzTitle]="'INTEGRATION.SFTP.LAST_IMPORT' | translate">{{ sftpIntegration.lastImport ? (importStatusLabel(sftpIntegration.lastImport.status) | translate) : '-' }}</nz-descriptions-item>
      <nz-descriptions-item [nzTitle]="'INTEGRATION.SFTP.LAST_IMPORT_FINISHED' | translate">{{ formatSftpDateTime(sftpIntegration.lastImport?.finishedAt) }}</nz-descriptions-item>
    </nz-descriptions>
    <nz-alert *ngIf="sftpIntegration.revocationRequired" nzType="warning" nzShowIcon [nzMessage]="'INTEGRATION.SFTP.REVOCATION_REQUIRED' | translate"></nz-alert>
  </div>

  <section class="sftp-phase4-section" *ngIf="isSftp">
    <div class="section-heading">
      <h3>{{ 'INTEGRATION.SFTP.HISTORY.TITLE' | translate }}</h3>
      <span>{{ 'INTEGRATION.SFTP.HISTORY.TOTAL' | translate:{ count: sftpHistoryTotal } }}</span>
    </div>
    <nz-table #sftpHistoryTable [nzData]="sftpHistory" [nzLoading]="sftpHistoryLoading" [nzFrontPagination]="false" [nzScroll]="{ x: '1260px' }">
      <thead>
        <tr>
          <th nzColumnKey="fileName" [nzSortOrder]="sftpHistorySortOrderFor('fileName')" (nzSortOrderChange)="onSftpHistorySortChange('fileName', $event)">{{ 'INTEGRATION.SFTP.HISTORY.FILE' | translate }}</th>
          <th nzColumnKey="receivedAt" [nzSortOrder]="sftpHistorySortOrderFor('receivedAt')" (nzSortOrderChange)="onSftpHistorySortChange('receivedAt', $event)">{{ 'INTEGRATION.SFTP.HISTORY.RECEIVED' | translate }}</th>
          <th nzColumnKey="status" [nzSortOrder]="sftpHistorySortOrderFor('status')" (nzSortOrderChange)="onSftpHistorySortChange('status', $event)">{{ 'INTEGRATION.SFTP.HISTORY.STATUS' | translate }}</th>
          <th nzColumnKey="createdCount" [nzSortOrder]="sftpHistorySortOrderFor('createdCount')" (nzSortOrderChange)="onSftpHistorySortChange('createdCount', $event)">{{ 'INTEGRATION.SFTP.HISTORY.CREATED' | translate }}</th>
          <th nzColumnKey="updatedCount" [nzSortOrder]="sftpHistorySortOrderFor('updatedCount')" (nzSortOrderChange)="onSftpHistorySortChange('updatedCount', $event)">{{ 'INTEGRATION.SFTP.HISTORY.UPDATED' | translate }}</th>
          <th nzColumnKey="skippedCount" [nzSortOrder]="sftpHistorySortOrderFor('skippedCount')" (nzSortOrderChange)="onSftpHistorySortChange('skippedCount', $event)">{{ 'INTEGRATION.SFTP.HISTORY.SKIPPED' | translate }}</th>
          <th nzColumnKey="failedCount" [nzSortOrder]="sftpHistorySortOrderFor('failedCount')" (nzSortOrderChange)="onSftpHistorySortChange('failedCount', $event)">{{ 'INTEGRATION.SFTP.HISTORY.FAILED' | translate }}</th>
          <th nzColumnKey="finishedAt" [nzSortOrder]="sftpHistorySortOrderFor('finishedAt')" (nzSortOrderChange)="onSftpHistorySortChange('finishedAt', $event)">{{ 'INTEGRATION.SFTP.HISTORY.FINISHED' | translate }}</th>
          <th *ngIf="canViewSftpImportResult"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of sftpHistoryTable.data">
          <td>{{ item.fileName || '-' }}</td>
          <td>{{ formatSftpDateTime(item.receivedAt || item.createdAt) }}</td>
          <td>{{ importStatusLabel(item.status) | translate }}</td>
          <td>{{ item.summary?.createdCount || 0 }}</td>
          <td>{{ item.summary?.updatedCount || 0 }}</td>
          <td>{{ item.summary?.skippedCount || 0 }}</td>
          <td>{{ item.summary?.failedCount || 0 }}</td>
          <td>{{ formatSftpDateTime(item.finishedAt) }}</td>
          <td *ngIf="canViewSftpImportResult">
            <button nz-button nzType="link" (click)="viewSftpImportResult(item.jobId)">{{ 'INTEGRATION.SFTP.HISTORY.VIEW_RESULT' | translate }}</button>
          </td>
        </tr>
        <tr *ngIf="!sftpHistoryLoading && sftpHistory.length === 0">
          <td [attr.colspan]="canViewSftpImportResult ? 9 : 8">{{ 'INTEGRATION.SFTP.HISTORY.EMPTY' | translate }}</td>
        </tr>
      </tbody>
    </nz-table>
    <div class="history-pagination" *ngIf="sftpHistoryTotal > 0">
      <nz-pagination
        [nzPageIndex]="sftpHistoryPage"
        [nzPageSize]="sftpHistoryLimit"
        [nzTotal]="sftpHistoryTotal"
        [nzPageSizeOptions]="[20, 50, 100]"
        [nzShowQuickJumper]="true"
        [nzShowSizeChanger]="true"
        (nzPageIndexChange)="onSftpHistoryPageChange($event)"
        (nzPageSizeChange)="onSftpHistoryPageSizeChange($event)"
      ></nz-pagination>
    </div>
  </section>

  <section class="sftp-phase4-section" *ngIf="isSftp">
    <div class="section-heading">
      <h3>{{ 'INTEGRATION.SFTP.NOTIFICATIONS.TITLE' | translate }}</h3>
      <span *ngIf="!canEditSftpNotifications">{{ 'INTEGRATION.SFTP.NOTIFICATIONS.READ_ONLY' | translate }}</span>
    </div>
    <div *ngIf="sftpNotificationLoading">{{ 'COMMON.LOADING' | translate }}</div>
    <ng-container *ngIf="!sftpNotificationLoading">
      <p>{{ 'INTEGRATION.SFTP.NOTIFICATIONS.DESCRIPTION' | translate }}</p>
      <div class="notification-events">
        <label nz-checkbox [(ngModel)]="sftpNotificationSettings.events.success" [nzDisabled]="!canEditSftpNotifications">{{ 'INTEGRATION.SFTP.NOTIFICATIONS.SUCCESS' | translate }}</label>
        <label nz-checkbox [(ngModel)]="sftpNotificationSettings.events.issues" [nzDisabled]="!canEditSftpNotifications">{{ 'INTEGRATION.SFTP.NOTIFICATIONS.ISSUES' | translate }}</label>
        <label nz-checkbox [(ngModel)]="sftpNotificationSettings.events.failure" [nzDisabled]="!canEditSftpNotifications">{{ 'INTEGRATION.SFTP.NOTIFICATIONS.FAILURE' | translate }}</label>
      </div>
      <div class="notification-recipients" *ngIf="canEditSftpNotifications">
        <label *ngFor="let recipient of sftpNotificationRecipients" nz-checkbox [ngModel]="sftpNotificationSettings.recipientUserIds.includes(recipient.id)" (ngModelChange)="toggleSftpNotificationRecipient(recipient.id, $event)">
          {{ recipient.displayName || recipient.email }} <span *ngIf="recipient.displayName">({{ recipient.email }})</span>
        </label>
      </div>
      <div class="notification-recipients" *ngIf="!canEditSftpNotifications">
        <span *ngIf="sftpNotificationSettings.recipientUserIds.length === 0">{{ 'INTEGRATION.SFTP.NOTIFICATIONS.NO_RECIPIENTS' | translate }}</span>
        <span *ngIf="sftpNotificationSettings.recipientUserIds.length > 0">{{ 'INTEGRATION.SFTP.NOTIFICATIONS.RECIPIENTS_CONFIGURED' | translate:{ count: sftpNotificationSettings.recipientUserIds.length } }}</span>
      </div>
      <button *ngIf="canEditSftpNotifications" nz-button nzType="primary" [nzLoading]="sftpNotificationSaving" (click)="saveSftpNotificationSettings()">{{ 'INTEGRATION.SFTP.NOTIFICATIONS.SAVE' | translate }}</button>
    </ng-container>
  </section>

  <div class="metrics" *ngIf="!isSftp && lastRun">
    <nz-descriptions nzBordered nzSize="small" [nzColumn]="2">
      <nz-descriptions-item [nzTitle]="'INTEGRATION.STATUS.LAST_RUN_STATUS' | translate">
        <nz-tag [nzColor]="runTagColor(lastRun.status)">{{ lastRun.status }}</nz-tag>
      </nz-descriptions-item>
      <nz-descriptions-item [nzTitle]="'INTEGRATION.STATUS.RUN_TYPE' | translate">
        {{ lastRun.runType || '-' }}
      </nz-descriptions-item>
      <nz-descriptions-item [nzTitle]="'INTEGRATION.STATUS.STARTED' | translate">
        {{ lastRun.startedAt || '-' }}
      </nz-descriptions-item>
      <nz-descriptions-item [nzTitle]="'INTEGRATION.STATUS.ENDED' | translate">
        {{ lastRun.endedAt || '-' }}
      </nz-descriptions-item>
      <nz-descriptions-item [nzTitle]="'INTEGRATION.STATUS.METRICS' | translate">
        <pre class="json">{{ lastRun.metrics | json }}</pre>
      </nz-descriptions-item>
      <nz-descriptions-item nzTitle=" "></nz-descriptions-item>
    </nz-descriptions>
  </div>

  <div class="run-picker" *ngIf="!isSftp">
    <div class="label">{{ 'INTEGRATION.STATUS.RUN_HISTORY' | translate }}</div>
    <nz-select
      style="min-width: 380px;"
      [ngModel]="selectedRunId"
      (ngModelChange)="selectedRunId = $event; onRunChange($event)"
      [nzLoading]="loadingRuns"
      [nzPlaceHolder]="'INTEGRATION.STATUS.SELECT_RUN_PLACEHOLDER' | translate"
    >
      <nz-option
        *ngFor="let r of runs"
        [nzValue]="r._id"
        [nzLabel]="(r.startedAt || '-') + ' — ' + (r.status || '-')"
      ></nz-option>
    </nz-select>
  </div>

  <h3 class="section-title" *ngIf="!isSftp">{{ 'INTEGRATION.STATUS.ERRORS' | translate }}</h3>

  <nz-table *ngIf="!isSftp" [nzData]="errors" [nzLoading]="loadingErrors">
    <thead>
    <tr>
      <th>{{ 'INTEGRATION.STATUS.TABLE.WHEN' | translate }}</th>
      <th>{{ 'INTEGRATION.STATUS.TABLE.ENTITY' | translate }}</th>
      <th>{{ 'INTEGRATION.STATUS.TABLE.EXTERNAL_ID' | translate }}</th>
      <th>{{ 'INTEGRATION.STATUS.TABLE.MESSAGE' | translate }}</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let e of errors">
      <td>{{ e.createdAt || '-' }}</td>
      <td>{{ e.entityType }}</td>
      <td>{{ e.externalId || '-' }}</td>
      <td>{{ e.message }}</td>
    </tr>
    <tr *ngIf="!loadingErrors && (!errors || errors.length === 0)">
      <td colspan="4">{{ 'INTEGRATION.STATUS.NO_ERRORS' | translate }}</td>
    </tr>
    </tbody>
  </nz-table>
</div>
